function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'debounce';
import './SearchField.scss';
import ErrorBoundary from './utils/ErrorBoundary';
export var SearchFieldContext = React.createContext({
  query: '',
  searchResults: []
});
/**
 * Search field that renders an input and contains any search agents.
 */

export var SearchField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SearchField, _Component);

  function SearchField(props, context) {
    var _this;

    _this = _Component.call(this, props, context) || this;

    _defineProperty(_assertThisInitialized(_this), "queueQuery", debounce(function (query) {
      _this.setState(function (state) {
        return {
          context: _this.getContextState({
            query: query,
            showResults: !!query,
            searchResults: []
          }, state)
        };
      });
    }, 500));

    _defineProperty(_assertThisInitialized(_this), "onResults", function (results) {
      _this.setState(function (state) {
        return {
          context: _this.getContextState({
            searchResults: [].concat(state.context.searchResults, results)
          }, state)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onQueryChange", function (query) {
      _this.queueQuery(query);

      _this.setState({
        fieldValue: query
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onItemSelect", function (item) {
      var _this$props = _this.props,
          onItemSelect = _this$props.onItemSelect,
          zoomOnSelect = _this$props.zoomOnSelect,
          mapContext = _this$props.mapContext;

      _this.setState(function (state) {
        return {
          fieldValue: item.title,
          context: _this.getContextState({
            showResults: false
          }, state)
        };
      });

      onItemSelect && onItemSelect(item);

      if (zoomOnSelect && item.olFeature && mapContext) {
        mapContext.setCenterAndZoom(item.olFeature.getGeometry().getCoordinates(), 14);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      var _this$state$context = _this.state.context,
          query = _this$state$context.query,
          showResults = _this$state$context.showResults;

      if (query && !showResults) {
        _this.setState(function (state) {
          return {
            context: _this.getContextState({
              showResults: true
            }, state)
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      _this.setState(function (state) {
        return {
          fieldValue: '',
          context: _this.getContextState({
            query: '',
            showResults: false,
            searchResults: []
          }, state)
        };
      });

      if (_this.props.onClear) _this.props.onClear();
    });

    _this.state = {
      fieldValue: '',
      context: _this.getContextState({
        query: '',
        showResults: false,
        searchResults: []
      })
    };
    return _this;
  }

  var _proto = SearchField.prototype;

  _proto.getContextState = function getContextState(state, prevState) {
    if (prevState === void 0) {
      prevState = {
        context: {}
      };
    }

    var _this$props2 = this.props,
        showLessText = _this$props2.showLessText,
        showMoreText = _this$props2.showMoreText,
        bbox = _this$props2.bbox;

    var _prevState$context$st = _extends({}, prevState.context, state),
        query = _prevState$context$st.query,
        showResults = _prevState$context$st.showResults,
        searchResults = _prevState$context$st.searchResults;

    return {
      onItemSelect: this.onItemSelect,
      onResults: this.onResults,
      query: query,
      showResults: showResults,
      searchResults: searchResults,
      showLessText: showLessText,
      showMoreText: showMoreText,
      bbox: bbox
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        children = _this$props3.children,
        placeholder = _this$props3.placeholder,
        clearTooltip = _this$props3.clearTooltip,
        canClearValue = _this$props3.canClearValue,
        required = _this$props3.required;
    var _this$state = this.state,
        fieldValue = _this$state.fieldValue,
        showResults = _this$state.context.showResults,
        context = _this$state.context;
    return /*#__PURE__*/React.createElement("div", {
      className: 'search-field ' + (showResults ? 'showResults' : ''),
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-field--field"
    }, (showResults || fieldValue && canClearValue) && /*#__PURE__*/React.createElement("button", {
      className: "search-field--clear",
      onClick: this.onClear,
      title: clearTooltip
    }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement("input", {
      type: "text",
      onChange: function onChange(e) {
        return _this2.onQueryChange(e.target.value);
      },
      onFocus: function onFocus(e) {
        return _this2.onFocus();
      },
      value: fieldValue,
      placeholder: placeholder,
      required: required
    })), /*#__PURE__*/React.createElement("div", {
      className: "search-field--agents"
    }, /*#__PURE__*/React.createElement(SearchFieldContext.Provider, {
      value: context
    }, children)));
  };

  return SearchField;
}(Component);

_defineProperty(SearchField, "defaultProps", {
  showMoreText: 'Show more results',
  showLessText: 'Show less results',
  clearTooltip: 'Clear',
  required: false
});

SearchField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Any type of child node is supported, but the SearchAgent nodes should be included
   * in the hierarchy below SearchField.
   */
  children: PropTypes.node,

  /**
   * Text used as placeholder in the text input field.
   */
  placeholder: PropTypes.string,

  /**
   * Text used in expand toggle when more results are available.
   */
  showMoreText: PropTypes.string,

  /**
   * Text used in collapse toggle when more results are displayed.
   */
  showLessText: PropTypes.string,

  /**
   * Tooltip (title attribute) on clear button.
   */
  clearTooltip: PropTypes.string,

  /**
   * Callback when an item is selected. This may be an item from any search agent.
   *
   * Use the SearchAgent prop onSelect to use a custom handler for each agent.
   */
  onItemSelect: PropTypes.func,

  /**
   * Callback when the field is cleared.
   */
  onClear: PropTypes.func,

  /**
   * If set, clear button is displayed whenever field has any value.
   */
  canClearValue: PropTypes.bool,

  /**
   * Boundary box (WKT) for prioritizing search results.
   */
  bbox: PropTypes.string,

  /**
   * If Map is available (use SearchFieldWithMap), zoom to items on select.
   */
  zoomOnSelect: PropTypes.bool,

  /**
  * If set to true, makes input field required.
  */
  required: PropTypes.bool,

  /**
   * @ignore
   */
  mapContext: PropTypes.object
} : {};

var SearchFieldWithErrorBoundary = function SearchFieldWithErrorBoundary(props) {
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(SearchField, props));
};

export default SearchFieldWithErrorBoundary;